import * as React from "react";
import { connect } from "react-redux";
//import * as ReactDOM from "react-dom";
import { Input } from "antd";
const Search = Input.Search;

interface ISelectPanel {
  data: any;
  size: Number;
  returnCheckedOpiton: any;
  // 返回当前实例的引用
  onRef: any;
  // 更新热键
  updateHotKey: any;
  value?: any;
}

// 下拉面板
class SelectPanel extends React.Component<ISelectPanel, any> {
  constructor(props: ISelectPanel) {
    super(props);
    this.state = {
      checkedList: Array<any>(),
      isAllChecked: false,
      // 呈现的数据
      renderData: [],
      // 筛选的关键字
      searchValue: "",
      // 当前实例的引用
      ref: null
    };

    this.props.onRef(this);
  }

  componentDidMount() {
    const value: any = this.props.value;
    let data: any; // (this.props.value && this.props.value.split(",")) || [];

    if (value) {
      if (typeof value === "string") {
        data = value.split(",");
      } else if (value instanceof Array) {
        data = value;
      }

      this.setState({
        checkedList: data
      });

      // 判断全选是否是选中状态
      if (this.props.data.length == data.length) {
        console.log("全选");
        this.setState({
          checkedAll: true
        });
      }

      // this.props.returnCheckedOpiton(data);
    }
  }

  // 选择数据项
  checkOption = id => {
    let checkedList = this.state.checkedList;
    const index = checkedList.findIndex(element => {
      return Number(element) === Number(id);
    });
    if (index != -1) {
      checkedList.splice(index, 1);
    } else {
      checkedList.push(id);
    }

    let newData = {
      checkedList: checkedList
    };

    if (checkedList.length != this.props.data.length) {
      newData["checkedAll"] = false;
    }

    this.setState(newData);
    this.props.returnCheckedOpiton(checkedList);
  };

  // 全选 or 全不选
  checkedAll = () => {
    let checkedList = Array<any>();
    if (this.state.checkedAll) {
      this.setState({
        checkedAll: false,
        checkedList: []
      });
    } else {
      checkedList = this.props.data.map(item => {
        return item.id;
      });
      this.setState({
        checkedAll: true,
        checkedList: checkedList
      });
    }
    this.props.returnCheckedOpiton(checkedList);
  };

  // 是否选中  true:选中
  isChecked = id => {
    return this.state.checkedList.some(item => {
      return Number(item) === Number(id);
    });
  };

  // 数据呈现
  showInfo = () => {
    const data = this.state.searchValue
      ? this.props.data.filter(item => {
        return item.name.indexOf(this.state.searchValue.trim()) != -1;
      })
      : this.props.data,
      size = Number(this.props.size);

    // 选中的样式
    const setCheckedClass = id => {
      return (
        "select-option " + (this.isChecked(id) && "select-option-activity")
      );
    };

    // 全选 or 全不选 样式
    const setAllChecked = () => {
      return (
        "select-option " + (this.state.checkedAll && "select-option-activity")
      );
    };

    const getItem = dataItem => {
      const itemClick = () => {
        this.checkOption(dataItem.id);
      };
      return (
        <a
          key={dataItem.id}
          className={setCheckedClass(dataItem.id)}
          onClick={itemClick}
        >
          {dataItem.name}
        </a>
      );
    };

    const getRow = (childElements, key = -1) => {
      return (
        <div key={key} className="select-option__row">
          {childElements}
        </div>
      );
    };

    let listInfo = Array<any>(),
      childElements = Array<any>();

    //有筛选值时不显示全选按钮
    if (!this.state.searchValue) {
      listInfo.push(
        <a
          key={-1}
          className={setAllChecked()}
          onClick={this.checkedAll}
        >
          全选
        </a>
      );
    }

    for (let i = 0; i < data.length; i++) {
      childElements.push(getItem(data[i]));
      if ((i + 1) % size === 0) {
        listInfo.push(getRow(childElements, i));
        childElements = [];
      }
    }

    // 最后一行的数据
    if (childElements.length > 0) {
      listInfo.push(getRow(childElements, data.length));
    }

    if (listInfo.length === 0) {
      return <div className="select-panel__empty">无匹配结果</div>;
    } else {
      return listInfo;
    }
  };

  // 筛选事件
  onSearch = (text, event) => {
    // this.setState({
    //   searchValue: text
    // });

    this.props.updateHotKey({
      hotkey: "enter",
      suspend: true
    });
    // console.log("updateHotKey", false);
  };

  onChange = e => {
    this.setState({
      searchValue: e.target.value
    });
  };

  // 取消选中某一项数据
  public unChecked = id => {
    let checkedList = this.state.checkedList;
    checkedList.splice(
      checkedList.findIndex(element => {
        return Number(element) === Number(id);
      }),
      1
    );
    this.setState({
      checkedAll: false,
      checkedList
    });
    this.props.returnCheckedOpiton(checkedList);
  };

  // 获取当前实例的引用
  getContentRef = ref => {
    this.setState({
      ref
    });
  };

  // 清除数据 列表和过滤文本框
  clear = () => {
    this.setState({
      checkedAll: false,
      searchValue: "",
      checkedList: []
    });
    this.props.returnCheckedOpiton([]);
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (
      this.props.value &&
      this.props.value.length > 0 &&
      ((nextProps.value && nextProps.value.length == 0) || !nextProps.value)
    ) {
      this.clear();
    }
    return true;
  }

  render() {
    return (
      <div className="select-panel" ref={this.getContentRef}>
        <Search
          placeholder="请输入关键字"
          onSearch={this.onSearch}
          onChange={this.onChange}
          value={this.state.searchValue}
          autoFocus={false}
          enterButton
        />
        <div className="option-container">{this.showInfo()}</div>
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    updateHotKey: dispatch.hotkey.updateHotKey
  };
};

export default connect(
  null,
  mapDispatch
)(SelectPanel);
